import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';

//import { ChartType, Row } from "angular-google-charts";

import { ConfigService } from '../../../services/config/config.service';
import { DataUserService } from '../../../services/data-user/data-user.service';
import { CatalogoService } from '../../../services/catalogo/catalogo.service';
import { VentaService } from '../../..//services/venta/venta.service';
import { ProveedorService } from '../../../services/proveedor/proveedor.service';
import { SeguimientoService } from '../../../services/seguimiento/seguimiento.service';
import { InventarioService } from '../../../services/inventario/inventario.service';
import { LoginService } from '../../../services/login/login.service';
import { TiendaService } from '../../../services/tienda/tienda.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service'
import { ProductoService } from '../../../services/producto/producto.service';
import { NotifyService } from '../../../services/notify/notify.service';



@Component({
  selector: 'app-begin',
  templateUrl: './begin.component.html',
  styleUrls: ['./begin.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class BeginComponent implements OnInit {
  //********* */ representación del grafico*********/
  @ViewChild("chart") chart: any;
  public chartOptions: any;
  @ViewChild("chart1") chart1: any;
  public chartOptions1: any;
  @ViewChild("chart2") chart2: any;
  public chartOptions2: any;
  //************************************************/
  load: boolean = false;
  token: any = {};
  empresa: Array<any> = [];
  menu: Array<any> = [];
  listCategorization: Array<any> = [];
  listProducts: Array<any> = [];
  listProductsStore: Array<any> = [];
  listSales: Array<any> = [];
  listSalesFilter: Array<any> = [];
  salesFilter: String = "";
  selectedSales: Array<any> = [];
  metodoPago: Array<any> = [];
  vendedor: Array<any> = [];
  infoUser: any = {};
  infoParametrizacion: any = {};
  loadMenu: boolean = false;
  display: boolean = false;
  alerts: Array<any> = [];
  ventaDia: number = 0;
  metaDiaria: number = 0;
  infoPagos: Array<any> = [];
  rangeDates: Date[] = [new Date(new Date().getFullYear(), (new Date().getMonth()), 1), new Date()];

  // canal de comunicacion
  channel = new BroadcastChannel('channelSession');


  constructor(private dataUser: DataUserService,
    private catalogo: CatalogoService,
    private venta: VentaService,
    private proveedor: ProveedorService,
    private message: MessageService,
    private seguimiento: SeguimientoService,
    private config: ConfigService,
    private inventario: InventarioService,
    private parametrizacion: LoginService,
    private tienda: TiendaService, private router: Router,
    private localizacion: LocalizacionService,
    private supplierIntegration: supplierIntegrationService,
    private producto: ProductoService,
    //private notify: NotifyService,
  ) {}

  ngOnInit(): void {
    /******************************Configuration Graphique ************************************************/
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor1 = documentStyle.getPropertyValue('--primary-color');
    const textColor2 = documentStyle.getPropertyValue('--colorSimescco');
    this.chartOptions = {
      series: [0, 0],
      chart: {
        width: 380,
        type: "donut",
        events: {
          legendClick: (event: any, chartContext: any, config: any) => {
            /* if ((config.config.labels[chartContext]) == "Meta") {
              document.getElementById('lblVenta')!.style!.fontWeight = "100"
              document.getElementById('lblMeta')!.style!.fontWeight = "Bold";
            }
            else {
              document.getElementById('lblMeta')!.style!.fontWeight = "100"
              document.getElementById('lblVenta')!.style!.fontWeight = "Bold";
            } */
          }
        }
      },
      labels: ["Venta", "Meta"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 260
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      fill: {
        colors: [textColor1, textColor2]
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");;
          }
        },
      }
    };



    this.chartOptions1 = {
      series: [{
        name: "Pago",
        data: [0, 0]
      }],
      chart: {
        height: 300,
        type: "bar"
      },
      plotOptions: {
        bar: {
          horizontal: false,
          dataLabels: {
            position: 'bottom'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ["", ""]
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return `${parseInt(value)}`
          }
        },
      },
      fill: {
        colors: [textColor1, textColor2]
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 260
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
    };

    this.chartOptions2 = {
      series: [0, 0],
      chart: {
        width: 380,
        type: "donut"
      },
      labels: ["Venta", "Meta"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 260
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ],
      fill: {
        colors: [textColor1, textColor2]
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return "$ " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        },
      }
    };
    /******************************Configuration Graphique ************************************************/
    //cargar token
    if (!!localStorage.getItem('token')) {
      this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
      this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "");

      //localStorage.clear()
      if (!localStorage.getItem('empresa')) {
        this.load = true;
        this.dataUser.getEmpresaVinculada(this.token.token).subscribe((response) => {
          this.empresa = response as Array<any>;
          localStorage.setItem('empresa', JSON.stringify(this.empresa));
          // información de la parametrización del cliente
          this.parametrizacion.parametrizacion(this.token.token, this.empresa[0].idProveedor).subscribe((response1) => {
            localStorage.setItem('parametros', JSON.stringify(response1));
            this.infoParametrizacion = response1 as object;

            if (!!this.infoParametrizacion.dataIntegrationUser) {
              //********************************** get Token SIIGO *******************************************
              const data: any = {
                "dataIntegrationUser": this.infoParametrizacion.dataIntegrationUser,
                "dataIntegrationApikey": this.infoParametrizacion.dataIntegrationApikey
              }
              this.supplierIntegration.getTokenSIIGO(this.token.token, data).subscribe({
                next: (response) => {
                  localStorage.setItem('tokenSIIGO', JSON.stringify(response));
                },
                error: (error: HttpErrorResponse) => {
                  this.alerts.push({
                    type: 'error',
                    text: 'Se ha presentado un error con el proveedor SIIGO, no es posible conectarse, cierre sesión e intente nuevamente'
                  });
                }
              });
            }
            //************************************************************************************************ */

            // load of states for invoicing
            this.localizacion.getDeptos(this.token.token, this.infoParametrizacion.idPaisVenta ?? 1).subscribe({
              next: (response) => { localStorage.setItem('listDptos', JSON.stringify(response as Array<any>)); },
              error: (error: HttpErrorResponse) => { this.config.handleError(error); }
            })


            // ************************************************************************************************/
            // get categorizacion de producto
            if (!localStorage.getItem("categorizationList"))
              this.producto.getCategorizacion(this.token.token).subscribe((response) => {
                this.listCategorization = response as Array<any>;
                localStorage.setItem("categorizationList", JSON.stringify(this.listCategorization))
              });
            else
              this.listCategorization = JSON.parse(localStorage.getItem("categorizationList") ?? "[]");


          });

          this.metaDiaria = this.empresa[0].tiendaEmpleados[0].idTiendaNavigation.metaTienda[0]?.valor ?? 0;

          //saber si esta vinculado a una tienda
          if (!this.empresa[0].tiendaEmpleados[0]) {
            this.alerts.push({
              type: 'error',
              text: 'No esta vinculado a una tienda, favor contactar a su administrador'
            });
          }

          // validación del pago
          if (parseInt(this.empresa[0].tiendaEmpleados[0].idTiendaNavigation.pagoPendiente ?? 0) > 0)
            this.alerts.push({
              type: 'warn',
              text: 'Olvidaste realizar el pago, favor ingresa y selecciona la entidad más cercana <a href="Pagos" class="p-button p-button-link p-0"> Realizar pago</a>'
            });

          // si es una empresa a la que pertenece el empleado no hay problema
          //informaciòn de pagos
          let fecha: Date = new Date();
          const dateConvert = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + "-" + fecha.getDate();
          this.seguimiento.getVentasDiscriminacionPago(this.token.token, dateConvert, dateConvert, this.infoUser.empleadoProveedors[0].idEmpleadoProveedor).subscribe((response) => {
            this.infoPagos = response as Array<any>;
            this.infoPagos.map(row => {
              // las nota credito no ingresan en el valor total de la venta
              if (row.idVentaMetodoPago != 4)
                this.ventaDia += row.valor;
            });
            //******************************************** begin graphique ***********************************************
            this.chartOptions.series = [this.ventaDia, ((this.metaDiaria - this.ventaDia) < 0) ? 0 : this.metaDiaria - this.ventaDia]
            //******************************************** End graphique ***********************************************
            // validar si hay una meta o  si no informar al usuario
            if (this.metaDiaria == 0)
              this.alerts.push({
                type: 'warn',
                text: 'No se ha establecido una meta, favor contactar a su administrador'
              });
            this.getRastreo();
          });

          //cargar menu
          this.dataUser.getMenuProfile(this.token.token).subscribe((response) => {
            this.menu = response as Array<any>;
            localStorage.setItem('menu', JSON.stringify(this.menu));
            this.loadMenu = true;


            // carga información esencial de productos
            this.catalogo.getProductos(this.token.token, !this.empresa[0].tiendaEmpleados ? 0 : this.empresa[0].tiendaEmpleados[0].idTienda).subscribe((response) => {
              this.listProducts = response as Array<any>;
              localStorage.setItem("listProducts", JSON.stringify(this.listProducts));

              // cargar información de pago
              this.venta.getMetodoPago(this.token.token).subscribe((response) => {
                this.metodoPago = response as Array<any>;
                localStorage.setItem("metodoPago", JSON.stringify(this.metodoPago));

                //obtener informaciòn de los vendedores que estan disponibles
                this.proveedor.getVendedoresActivos(this.token.token, 4).subscribe((response) => {
                  let array: any = response as Array<any>;
                  this.listSales = array.map((item: any) => {
                    return {
                      id: item.idEmpleadoProveedor,
                      label: item.idEmpleadoNavigation.nombres + " " + item.idEmpleadoNavigation.apellidos
                    }
                  });
                  localStorage.setItem("vendedoresDisponibles", JSON.stringify(this.listSales));
                  this.load = false;
                })

                // carga  información de vendedores tienda
                this.venta.getVendedorTienda(this.token.token, this.empresa[0].tiendaEmpleados[0].idTienda).subscribe((response) => {
                  this.vendedor = response as Array<any>;
                  // mapeando el vendedor
                  this.vendedor = this.vendedor.map((item) => {
                    return {
                      id: item.idEmpleadoProveedor,
                      label: item.idEmpleadoProveedorNavigation.idEmpleadoNavigation.nombres + " " + item.idEmpleadoProveedorNavigation.idEmpleadoNavigation.apellidos
                    }
                  });
                  // recordar seleccionar vendedores
                  if (this.vendedor.length == 0) {
                    this.alerts.push({
                      type: 'warn',
                      text: 'Favor realice la asignación de vendedores'
                    });
                  }
                  localStorage.setItem("vendedor", JSON.stringify(this.vendedor));
                  this.load = false;

                  //llamar canal para que se haga un reload
                  this.channel.postMessage('reload');
                })
              });
            })
          });
          this.getInfoCumulativeSales();
        });
      }
      else {
        this.empresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
        this.vendedor = JSON.parse(localStorage.getItem("vendedor") ?? "[]");
        this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
        this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");


        this.loadMenu = true;
        this.metaDiaria = this.empresa[0].tiendaEmpleados[0].idTiendaNavigation.metaTienda[0]?.valor ?? 0;
        //informaciòn de la grafica
        let fecha: Date = new Date();
        const dateConvert = fecha.getFullYear() + '-' + (fecha.getMonth() + 1) + "-" + fecha.getDate();
        this.seguimiento.getVentasDiscriminacionPago(this.token.token, dateConvert, dateConvert, this.infoUser.empleadoProveedors[0].idEmpleadoProveedor).subscribe((response) => {
          this.infoPagos = response as Array<any>;
          this.infoPagos.forEach(row => {
            // las nota credito no ingresan en el valor total de la venta
            if (row.idVentaMetodoPago != 4)
              this.ventaDia += row.valor;
          });
          //******************************************** begin graphique ***********************************************
          this.chartOptions.series = [this.ventaDia, ((this.metaDiaria - this.ventaDia) < 0) ? 0 : this.metaDiaria - this.ventaDia]
          //******************************************** End graphique ***********************************************
        });
        // validar si hay una meta o  si no informar al usuario
        if (this.metaDiaria == 0)
          this.alerts.push({
            type: 'warn',
            text: 'No se ha establecido una meta, favor contactar a su administrador'
          });
        //saber si esta vinculado a una tienda
        if (!this.empresa[0].tiendaEmpleados[0]) {
          this.alerts.push({
            type: 'error',
            text: 'No esta vinculado a una tienda, favor contactar a su administrador'
          });

        }
        // recordar seleccionar vendedores
        if (this.vendedor.length == 0) {
          this.alerts.push({
            type: 'warn',
            text: 'Favor realice la asignación de vendedores'
          });
        }
        // validación del pago
        if (parseInt(this.empresa[0].tiendaEmpleados[0].idTiendaNavigation.pagoPendiente ?? 0) > 0)
          this.alerts.push({
            type: 'warn',
            text: 'Olvidaste realizar el pago, favor ingresa y selecciona la entidad más cercana <a href="integracion/pagos_servicio" class="p-button p-button-link p-0"> Realizar pago</a>'
          });

        this.getRastreo();
      }

      this.getInfoCumulativeSales();

    }
  }

  asignarSales = () => {
    if (this.selectedSales.length > 0) {
      this.load = true;
      this.vendedor = [];
      this.selectedSales.forEach((row => {
        this.vendedor.push(this.listSales.filter(item => { return item.id == row })[0]);
      }));
      localStorage.setItem("vendedor", JSON.stringify(this.vendedor));
      //enviar a base de datos la información para asignación de la meta
      let data: Array<any> = [];
      this.selectedSales.forEach((row => {
        data.push({
          idTienda: this.empresa[0].tiendaEmpleados[0].idTienda,
          idEmpleadoProveedor: row,
          activo: true
        });
      }));

      this.proveedor.setUsersTienda(this.token.token, data, 4).subscribe({
        next: (response) => {
          this.message.add({ severity: 'success', summary: 'Información', detail: response.toString() });
          this.load = false;
          this.display = false;
        }, error: (error: HttpErrorResponse) => {
          this.config.handleError(error);
        }
      })
    }
    else {
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'Favor relacione los vendedores para inicio de jornada' });
    }


  }

  verAsignacionSales = () => {
    this.display = true;
    this.listSales = JSON.parse(localStorage.getItem("vendedoresDisponibles") ?? "[]");
    this.listSalesFilter = this.listSales;
    this.vendedor = JSON.parse(localStorage.getItem("vendedor") ?? "[]");
    this.selectedSales = this.vendedor.map(row => {
      return row.id.toString();
    });
  }

  filterSales = () => {
    this.listSalesFilter = this.listSales.filter((row: any) => {
      return row.label.toUpperCase().indexOf(this.salesFilter.toUpperCase()) > -1
    })
  }


  getRastreo = () => {
    // revisar si alguna tienda a enviado algo
    this.inventario.getRastreoMovimiento(this.token.token, this.empresa[0].tiendaEmpleados[0].idTienda).subscribe((response) => {
      (response as Array<any>).map((row: any) => {
        this.alerts.push({
          type: 'warn',
          text: 'Tiene pendiente el ingreso de la mercancia enviada por la tienda: <b>' + row.idTiendaOrigenNavigation.nombreTienda
            + '</b>, para su posterior registro.<a href="Movimientos" class="p-button p-button-link p-0"><i class="pi pi-eye"></i> Registrar información</a>'
        })
      })

    })
  }


  getInfoCumulativeSales = () => {
    if (!!this.empresa) {
      // load sales made of date range
      const dateConvertBegin: string = this.rangeDates[0].getFullYear() + '-' + (this.rangeDates[0].getMonth() + 1) + "-" + this.rangeDates[0].getDate();
      const dateConvertEnd: string = this.rangeDates[1].getFullYear() + '-' + (this.rangeDates[1].getMonth() + 1) + "-" + this.rangeDates[1].getDate();
      const idTienda: number = !this.empresa[0]?.hasOwnProperty('tiendaEmpleados') ? 0 : this.empresa[0].tiendaEmpleados[0].idTiendaNavigation.idTienda

      //consultar la informaciòn de resumen de pago de cada tienda segun la fecha
      this.tienda.getVentasDiscriminacionPagoTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, idTienda).subscribe({
        next: (response) => {
          const data: any = response as Array<any>;
          let reference: any = [];
          let value: any = [];
          let cumulativeValue: number = 0;
          let cumulativeGoal: number = 0;
          //sort array sorting by attr:valor
          let sortArray: Array<any> = data.sort((a: any, b: any) => b.valor - a.valor)
          // map array
          sortArray.map((row: any) => {
            // las nota credito no ingresan en el valor total de la venta
            if (row.idVentaMetodoPago != 4) {
              cumulativeValue += row.valor
              reference.push(row.referencia),
                value.push(row.valor)
            }
          });


          this.chartOptions1.series = [{
            name: "Pago",
            data: value
          }];

          this.chartOptions1.xaxis = {
            categories: reference
          }

          //get goal
          this.tienda.getMetasTiendaAcumulado(this.token.token, dateConvertBegin, dateConvertEnd, idTienda).subscribe({
            next: (data: any) => {
              if (data.length > 0)
                cumulativeGoal = data[0].valor ?? 0;
              this.chartOptions2.series = [cumulativeValue, ((cumulativeGoal - cumulativeValue) < 0) ? 0 : cumulativeGoal - cumulativeValue]
            },
            error: (error: HttpErrorResponse) => {
              this.config.handleError(error);
              this.message.add({ severity: 'error', summary: 'Información', detail: 'Se ha presentado un error' });
              this.load = false;
            }
          });

        },
        error: (error: HttpErrorResponse) => {
          this.config.handleError(error);
          this.message.add({ severity: 'error', summary: 'Información', detail: 'Se ha presentado un error' });
          this.load = false;
        }
      })
    }
  }



}
